import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { useStore } from 'core/store/store.mobx';
import { Grid, Button } from '@material-ui/core';
import { useFormikContext } from 'formik';
import { useHistory } from 'react-router-dom';

import useStyles from '../../dialog.styles';
import { Label } from 'core/components/label';
import { DriverCard, DriversLicenseCard } from './components';
import { MVRErrors } from 'core/store/offer-store/offer-store';

const MVRRetry = observer(function MVRRetry() {
  const { offer: store } = useStore();
  const classes = useStyles();
  const history = useHistory();
  const { setFieldValue, submitForm } = useFormikContext();

  // the lambda will return the results of the MVR calls in the error message as err.data
  const drivers = store.errors.find((err) => MVRErrors[err.code] === MVRErrors.MVR_RETRY).data;

  useEffect(() => {
    // have to do this to make the error messages show up correctly
    const cleanedDrivers = drivers.map((driver) => {
      driver.driversLicenseState = driver.driversLicenseState || '';
      driver.driversLicenseNumber = driver.driversLicenseNumber || '';
      return driver;
    });
    setFieldValue('drivers', cleanedDrivers);
  }, [setFieldValue, drivers]);

  const onClick = () => {
    store.triggerOfferDialog(false);
    history.push({ pathname: `/offer/${store.offer.id}` });
  };

  return (
    <>
      <Grid container className={classes.contentWrapper}>
        <Label type="titleSecondary" className={classes.title}>
          Purchase Failed - Couldn&rsquo;t find Motor vehicle Record
        </Label>
        <Label type="infoInnerTitle">
          We could not find MVR for the following drivers. This may be resolved by providing the drivers license for the
          drivers who are missing MVRs.
        </Label>
      </Grid>

      <Label type="infoSubtitle" style={{ paddingBottom: '8px' }}>
        Drivers
      </Label>
      {drivers?.map((driver, index) =>
        driver.gotDrivingRecord ? (
          <DriverCard driver={driver} key={driver.id} />
        ) : (
          <DriversLicenseCard driver={driver} index={index} key={driver.id} />
        )
      )}
      <Grid container alignItems="center" justifyContent="flex-end" className={classes.bottom}>
        <Button onClick={onClick} variant="text" color="secondary" className={classes.btnSmall}>
          <Label className={classes.btnLabel}>Back To Offer</Label>
        </Button>
        <Button onClick={submitForm} variant="contained" color="primary" className={classes.btnSmall}>
          <Label className={classes.btnLabel}>Buy Now</Label>
        </Button>
      </Grid>
    </>
  );
});

export default MVRRetry;
